import { medicationsTypesActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_MEDICATION_TYPE,
  FETCHING_MEDICATION_TYPE,
  FETCH_MEDICATION_TYPE_ERROR,
  FETCH_MEDICATIONS_TYPES,
  FETCHING_MEDICATIONS_TYPES,
  FETCH_MEDICATIONS_TYPES_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_MEDICATION_TYPE,
  DELETE_MEDICATION_TYPE,
  ADD_MEDICATION_TYPE,
  EDIT_MEDICATION_TYPE,
  FORM_TOUCHED,
  NEW_FORM_MEDICATION_TYPE,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  MEDICATION_TYPE_FORM_ERROR,
  RESET_STATE
} = medicationsTypesActions

const initialState = {
  loadingMedicationType: false,
  loadingMedicationsTypes: false,
  fetchMedicationTypeError: false,
  fetchMedicationsTypesError: false,
  medicationsTypes: [],
  order: {
    column: 'nome',
    direction: 1
  },
  medicationType: {
    nome: ''
  },
  medicationsTypesPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  medicationTypeFormErrors: {},
  medicationTypeFormTouched: false,
  modalOpen: false
}

const medicationTypeSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    }
  }
}

const MedicationTypeValidate = new ValidateFormObject(medicationTypeSchema)

const medicationsTypes = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_MEDICATION_TYPE:
      formSchemaType = action.medicationType._id ? 'edit' : 'add'
      return {
        ...state,
        medicationType: action.medicationType,
        medicationTypeFormErrors: MedicationTypeValidate.validate({
          formObject: action.medicationType,
          formSchemaType
        })
      }
    case MEDICATION_TYPE_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.medicationType._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        medicationTypeFormErrors: MedicationTypeValidate.validate({
          formObject: state.medicationType,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_MEDICATION_TYPE:
      return {
        ...state,
        medicationType: { ...initialState.medicationType },
        medicationTypeFormErrors: MedicationTypeValidate.validate({}),
        medicationTypeFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        medicationTypeFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_MEDICATION_TYPE:
      formSchemaType = (action.medicationType || {})._id ? 'edit' : 'add'
      return {
        ...state,
        medicationType: action.medicationType,
        loadingMedicationType: false,
        fetchmedicationTypeError: false,
        medicationTypeFormTouched: false,
        medicationTypeFormErrors: MedicationTypeValidate.validate({
          formObject: action.medicationType,
          formSchemaType
        })
      }
    case FETCHING_MEDICATION_TYPE:
      return {
        ...state,
        loadingMedicationType: true,
        fetchMedicationTypeError: false
      }
    case DELETE_MEDICATION_TYPE:
      return {
        ...state,
        loadingMedicationsTypes: false,
        fetchMedicationTypeError: false,
        medicationsTypes: state.medicationsTypes.map(medicationType => {
          if (medicationType._id === (action.medicationType || {})._id) {
            return action.medicationType
          }
          return medicationType
        })
      }
    case FETCH_MEDICATION_TYPE_ERROR:
      return {
        ...state,
        loadingMedicationType: false,
        medicationType: { ...initialState.medicationType },
        fetchMedicationTypeError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        medicationsTypesPagination: {
          ...state.medicationsTypesPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        medicationsTypesPagination: {
          ...state.medicationsTypesPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_MEDICATIONS_TYPES:
      return {
        ...state,
        loadingMedicationsTypes: false,
        medicationsTypes: action.medicationsTypes,
        fetchMedicationsTypesError: false,
        order: action.order,
        medicationsTypesPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_MEDICATION_TYPE:
      return {
        ...state,
        medicationsTypes: state.medicationsTypes.map(medicationType => {
          if (medicationType._id === action.medicationType._id) {
            return action.medicationType
          }
          return medicationType
        }),
        loadingMedicationsTypes: false,
        fetchMedicationTypeError: false,
        loadingMedicationType: false,
        fetchMedicationsTypesError: false
      }
    case FETCHING_MEDICATIONS_TYPES:
      return {
        ...state,
        loadingMedicationsTypes: true,
        fetchMedicationsTypesError: false
      }
    case FETCH_MEDICATIONS_TYPES_ERROR:
      return {
        ...state,
        loadingMedicationsTypes: false,
        fetchMedicationTypeError: action.error,
        loadingMedicationType: false
      }
    case ADD_MEDICATION_TYPE:
      return {
        ...state,
        loadingMedicationsTypes: false,
        fetchMedicationTypeError: false,
        loadingMedicationType: false,
        medicationsTypes: [...state.medicationsTypes, action.medicationType]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default medicationsTypes



// WEBPACK FOOTER //
// ./src/reducers/medicationsTypes.js